import React from 'react'

import Select, { SelectProps } from '~elements/SelectV2'
import { AssetTypeOption } from '~entities/assets'
import { AssetTypes } from '~generated/types'
import { stopPropagation } from '~lib/helpers'
import Option from '~lib/ui-kit/Option'

interface AssetTypeSelectProps extends SelectProps {
  options: AssetTypeOption[]
  value: AssetTypes
  onChange: (value: AssetTypes) => void
}

function AssetTypeSelect({ options, value, onChange, ...props }: AssetTypeSelectProps) {
  const renderIcon = (type: AssetTypes) => {
    const option = options.find((option) => option.value === type)

    if (option) {
      return option.getIcon()
    }

    return null
  }

  return (
    <Select
      label="Asset type"
      variant="dark"
      bordered
      fitContent
      value={value}
      onChange={onChange}
      onClick={stopPropagation}
      renderIcon={renderIcon}
      tabIndex={0}
      {...props}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value} icon={option.getIcon()}>
          {option.label}
        </Option>
      ))}
    </Select>
  )
}

export default React.memo(AssetTypeSelect)
